import { useEffect, useState } from "react"
import { Card } from "~/ui-rtk/components/ui/common"
import { Button } from "~/ui-rtk/components/ui/controls"
import { H3, P } from "~/ui-rtk/components/ui/typography"
import { copyTextToClipboard } from "~/ui-rtk/utils/clipboard"

// ponytail: there is exactly one remote MCP server (stage has none), so the
// URL is a constant. Move it to a VITE_* var if a second host ever appears.
export const MCP_SERVER_URL = "https://mcp.marathondataco.com/mcp"

const STEPS = [
  "In Claude, open Settings, then Connectors, and choose Add custom connector.",
  "Name it Marathon Data and paste the server URL above. Leave the OAuth and transport options on their defaults.",
  "Click Add, then Connect. A Marathon sign-in page opens; sign in with the email and password you use here.",
  "Back in Claude, switch the Marathon Data connector on in a chat and ask about your performance.",
]

export default function SettingsClaudePage() {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    document.title = "Marathon Data: Settings > Claude"
  }, [])

  const handleCopy = async () => {
    await copyTextToClipboard(MCP_SERVER_URL)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="py-6 flex flex-col gap-6 max-w-3xl">
      <div>
        <H3>Connect Claude</H3>
        <P className="my-3">
          Ask Claude about your Marathon data in plain language. Claude connects
          to Marathon as you, so it can see and do exactly what you can here,
          and it asks before making any change.
        </P>
      </div>

      <Card className="border bg-basic-black border-basic-blue" rounded>
        <div className="flex flex-col gap-4">
          <P className="font-semibold">Server URL</P>
          <div className="flex items-center gap-2">
            <code className="flex-1 p-3 text-sm break-all rounded-lg border border-basic-blue bg-basic-dark-blue font-mono">
              {MCP_SERVER_URL}
            </code>
            <Button
              variant={{ variant: "solid", color: "white" }}
              size="sm"
              onClick={handleCopy}
            >
              {copied ? "Copied" : "Copy"}
            </Button>
          </div>
          <ol className="list-decimal pl-5 flex flex-col gap-2">
            {STEPS.map(step => (
              <li key={step}>
                <P>{step}</P>
              </li>
            ))}
          </ol>
        </div>
      </Card>

      <div className="flex flex-col gap-3">
        <P>
          The connection works everywhere you use Claude: the web app, the
          desktop and mobile apps, Cowork, and Claude Code.
        </P>
        <P>
          On a Claude Team or Enterprise plan, an Owner can add the connector
          once for the whole organization under Organization settings, then
          Connectors. Each person still signs in to Marathon individually. On
          the Free plan Claude allows one custom connector.
        </P>
        <P className="text-basic-grey-inactive">
          Prefer scripts or the command line? API keys are on the API Keys tab.
        </P>
      </div>
    </div>
  )
}
